import React from 'react';
import styled from 'styled-components/macro';
import { forMinWidth } from '../../../theme/breakpoints';
import { TimelineItem } from '../../../hooks/posts';
import Avatar from '../../shared/Avatar';

export interface TimelineItemComponentProps {
    timelineItem: TimelineItem;
    className?: string;
    showConnectingLine?: boolean;
    renderItem?: (timelineItem: TimelineItem) => JSX.Element;
}

export default function TimelineItemComponent(props: TimelineItemComponentProps): JSX.Element {
    const { timelineItem, className, showConnectingLine } = props;
    const timelineDepth = props.timelineItem.timelineDepth ?? 0;

    return <Wrapper className={`timeline-item ${className ?? ''}`}>
        <Logo>
            <Avatar
                className="avatar-logo"
                name={timelineItem.authorName}
                imageUrl={timelineItem.logoImageUrl}
                imageTooltip={timelineItem.logoTooltip}
            />
        </Logo>

        {showConnectingLine && <Line timelineDepth={timelineDepth} />}

        <MainContent>
            {props.renderItem && props.renderItem(timelineItem)}
        </MainContent>

    </Wrapper>
}

const Wrapper = styled.div`
    display: flex;
    position: relative;
`;

const Logo = styled.span`
    margin-left: var(--timeline-left-margin);
    width: var(--timeline-logo-panel-width);
    z-index: 10;

    .avatar-logo {
        margin-top: var(--timeline-logo-top-margin);
        width: var(--timeline-logo-width);
        height: var(--timeline-logo-width);
        font-size: var(--timeline-logo-font-size);
        white-space: nowrap;
    }
`;

export const LogoPointer = styled.span<{ timelineDepth: number }>`
    display: none;
    position: absolute;
    left: calc(-1 * var(--timeline-logo-pointer-size) / 2);
    top: calc(var(--timeline-header-min-height) / 2 - var(--timeline-logo-pointer-size) / 2 + var(--timeline-logo-top-offset));
    transform: rotate(45deg);
    background-color: var(--titlebar-background-color);

    height: var(--timeline-logo-pointer-size);
    width: var(--timeline-logo-pointer-size);

    &.logo-pointer-bordered {
        border: solid 1px var(--timeline-logo-pointer-border-color);
        border-top: none;
        border-right: none;
    }

    ${forMinWidth.sm`
        display: block;
    `}
`;

const MainContent = styled.span`
    position: relative;
    width: 100%;
`;

const Line = styled.div<{ timelineDepth: number }>`
    position: absolute;
    background-color: var(--timeline-line-color);
    margin-left: calc(var(--timeline-left-margin) + (var(--timeline-logo-width) - var(--timeline-line-width)) / 2);
    width: var(--timeline-line-width);
    margin-top: var(--timeline-logo-width);
    height: 100%;
    z-index: 0;
`;
